import { SchemaVariant } from '@morph-mapper/types';
import type { PluginProviderCtx, UtilsApi } from '../types';
import { useGlobalPluginStore } from '../store';

export const createUtilsApi = (
  textContent: string,
  createCallRender: PluginProviderCtx['createCallRender'],
  createLLMExtract: PluginProviderCtx['createLLMExtract'],
): UtilsApi => {
  const { fileType } = useGlobalPluginStore.getState();

  const getFileType = (): SchemaVariant => fileType;

  return {
    getFileType,
    callRender: createCallRender(textContent),
    createCallRender,
    extractWithLLM: createLLMExtract(),
  };
};
